import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskDataClassificationsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-data-classifications',
	path: '/jira/servicedesk/projects/:projectKey/settings/data-classifications',
	exact: true,
};
